import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { EncrDecrService } from './../../services/encr-decr.service';


@Component({
  selector: 'app-s-view-customer',
  templateUrl: './s-view-customer.component.html',
  styleUrls: ['./s-view-customer.component.css']
})
export class SViewCustomerComponent implements OnInit {
   
  user_id: any='';
  token:any='';
  APIKEY:any= 'SOAV2@123';
  buttonDisabled: boolean;
  model: any = {};
  myDateValue: Date;
  factLanguage: any = {};
  arr: any[]=[];    
  key_info:any={};
  company_id:any=0;
  edit_factoring_mode:boolean=false;

  constructor( private _company:CompanyService,
    private _factLang:FactLanguageService,
    private _router : Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.token =localStorage.getItem('token');

    this._activatedroute.params.subscribe(params => {
      this.company_id = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });

    // this._activatedroute.params.subscribe(params => {
    //   this.company_id = params['id'];
    // });

    this.get_company_by_id();
   
    this.myDateValue = new Date();
   
  }

  onSubmit(form) {
   
      this.model["company_id"] = this.company_id;
      this.model["APIKEY"] = this.APIKEY;
      //console.log(this.model);  return false;   
      this._company.updateCmp(this.model)
      .subscribe(
        res => {  
            if(res.status==true){
              this.toastr.success(res.message, 'Success');
            }
            else{
              this.toastr.error(res.message, 'Error');
            }
          this._router.navigate(['super-admin/customer-list']);
        },
      );
  }

  
  get_company_by_id(){
   const data = {
      company_id:this.company_id,
      APIKEY : this.APIKEY
    }
   this._company.getCompanyById(data)
      .subscribe(
        res => {
          if(res.data.edit_factoring==1){
             this.edit_factoring_mode=true;
          }
            
          
            this.model=res.data;
            this.model.password = this.EncrDecr.get(localStorage.getItem('key'), this.model.password);
          console.log(this.model);
          
        },
        err => console.log(err)
     );
   }

}
